import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';

import {
  resetFromQueryPaste,
  search,
  userType,
  userEnhancedQueryByPasting,
  manualSubmitSearch,
  updateQuery,
} from '../../../state/actions';
import { StateType } from '../../../../state/state.types';

const mapState = ({ queryParams }: StateType) => ({
  query: queryParams.userQuery,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onUserType(query: string) {
    dispatch(userType(query));
  },
  onQueryPaste(query: string, isQueryEnhanced: boolean) {
    if (isQueryEnhanced) {
      dispatch(userEnhancedQueryByPasting(query));
      dispatch(userType(query));
    } else {
      dispatch(resetFromQueryPaste(query));
    }
  },
  submitCurrentQuery(query: string) {
    // usefull for replay query inside search bar from decision page
    dispatch(updateQuery(query));
    dispatch(manualSubmitSearch());
    dispatch(search({ reason: 'button_submit' }));
  },
  followAutocomplete(query: string, reason: string) {
    dispatch(userType(query));
    dispatch(manualSubmitSearch());
    dispatch(search({ reason }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
